import { useState, useRef, useEffect } from "react";
import "./StockChatBot.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import {APP_URL,API_ENDPOINT, toast_anim , pdfdoconly, cleanCompanyName} from '../../config/Common'


export default function StockChatBot({ companyinfo, isOpen, toggleChat }) {
  
  //console.log("companyinfo in stock chatbot", companyinfo);

  const [typing, setTyping] = useState(false);
  const [messages, setMessages] = useState([]);
  const [stockQuestions, setStockQuestions] = useState([]);

  const bottomRef = useRef(null);

  useEffect(() => {
      bottomRef.current?.scrollIntoView({
          behavior: "smooth"
      });
  }, [messages]);

  useEffect(() => {
    const fetchStockQuestions = async () => {
      const questions = await getStockQuestions();
    };

    fetchStockQuestions();
  }, [companyinfo]);

  const [input, setInput] = useState("");

  const getStockQuestions = async () => {
    try {
        const response = await fetch(`${API_ENDPOINT}/stock-questions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify({
                stock_name: cleanCompanyName(companyinfo?.name) || "",
                stock_symbol: companyinfo?.symbol || "",
            }),
        });

        const data = await response.json();
        //console.log("Stock Questions data=====", data);
        setStockQuestions(data.questions || []);
        //return data.questions || [];
    } catch (error) {
        //console.error(error);
        return [];
    }
  };

  const sendMessage = async (input) => {
    if (!input.trim()) return;

    const message = input;

    const updatedMessages = [
    ...messages,
    {
        role: "user",
        parts: [
            {
                text: message
            }
        ]
    }
];

setMessages(updatedMessages);

    // Add user message
    // setMessages((prev) => [
    //     ...prev,
    //     {
    //         role: "user",            
    //         parts: [
    //             {
    //                 text: message
    //             }
    //         ]
    //     },
    // ]);

    setInput("");
    setTyping(true);
    //console.log(JSON.stringify(updatedMessages, null, 2));
    try {
        const response = await fetch(`${API_ENDPOINT}/stock-chat`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify({
                contents: updatedMessages,
                stock_name: cleanCompanyName(companyinfo?.name) || "",
                stock_symbol: companyinfo?.symbol || "",
            }),
        });

        const data = await response.json();
        setTyping(false);
        console.log("data=====", data);

        const botMessage = {
            role: "model",
            parts: [
                {
                    text: data.reply
                }
            ]
        };

        setMessages(prev => [...prev, botMessage]);

        // setMessages((prev) => [
        //     ...prev,
        //     {
        //         role: "bot",
        //         parts: [
        //             {
        //                 text: data.reply
        //             }
        //         ]
        //     },
        // ]);
    } catch (error) {
        //console.error(error);
        setTyping(false);
        setMessages((prev) => [
            ...prev,
            {
                role: "model",
                parts: [
                    {
                        text: "Sorry, something went wrong."
                    }
                ]
            },
        ]);
    }
};

  return (
    <>
    {/*  !isOpen && 
    <button
        className="chat-toggle"
        onClick={toggleChat}
      >
        Ask AI
      </button>
*/}
      {isOpen && (
        <div className="chat-popup">
          
          <div className="chat-header flex justify-between items-center">
             <div>{cleanCompanyName(companyinfo?.name)} ({companyinfo?.symbol})</div>
            <button className="close-btn" onClick={toggleChat}>
              ✕
            </button>
          </div>

          <div className="chat-body">
            <div className="text-center text-2xl mb-4">
              Hello, how can I help you with {cleanCompanyName(companyinfo?.name)}?
            </div>
            <div className="flex flex-row gap-3 mb-4 flex-wrap justify-center">
            {
              stockQuestions.map((question, index) => (
                <div key={index} className="bg-gray-200 hover:bg-gray-300 p-2 rounded cursor-pointer" onClick={() => sendMessage(question)}>
                  {question}
                </div>
              ))
            }
            </div>

            {messages.map((msg, index) => (
              <div
                key={index}
                className={`message ${msg.role === "user" ? "user" : "bot"}`}
              >
                <div className="markdown">
                <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                    {msg.parts[0].text}
                </ReactMarkdown>
              </div>
              </div>
            ))}
            {typing && (
                <div className="message bot typing">
                    AI is typing...
                </div>
            )}
            <div ref={bottomRef} />

          </div>

          {/* <div className="chat-footer">

            <input
              type="text"
              placeholder="Type message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") sendMessage();
              }}
            />

            <button onClick={sendMessage}>
              Send
            </button>

          </div> */}

        </div>
      )}
    </>
  );
}